import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tw-p-10 modal-manage-domain" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-[15px]" }
const _hoisted_3 = { class: "tw-text-[25px] tw-text-[#211F58] tw-font-[600] tw-leading-none" }
const _hoisted_4 = {
  key: 0,
  class: "status-domain tw-items-center tw-inline-flex"
}
const _hoisted_5 = { class: "tw-text-[#211F58] tw-text-[15px]" }
const _hoisted_6 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]" }
const _hoisted_7 = {
  key: 1,
  class: "tw-p-[40px] tw-mt-[40px] tw-bg-[#F7F7F8] tw-rounded tw-border tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_8 = { class: "tw-text-[16px] tw-font-[600] tw-text-[#211F58]" }
const _hoisted_9 = { class: "tw-mt-[10px] tw-mb-0 tw-text-[15px] tw-text-[#231F20]" }
const _hoisted_10 = { class: "button-container tw-flex tw-justify-end tw-mt-[40px]" }
const _hoisted_11 = { class: "button-container-left tw-flex-1" }
const _hoisted_12 = {
  key: 0,
  class: "button-container-right"
}

import get from "lodash/get";
import store from "../../store";
import utilities, { getComponentUiText } from "../../utils/utilities";
import { PropType, Ref, computed, ref, watch } from "vue";
import Modal from "../common/modal.vue";
import ModalHeader from "../common/modalHeader.vue";
import CopyInfo from "@/components/common/copyInfo.vue";
import NoteInfo from "@/components/common/noteInfo.vue";
import VRuntimeTemplate from "vue3-runtime-template";
import { manageDomainActions } from "@/utils/constants";
import ProgressAnimation from "@/assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";
import { IDomain } from "@/interfaces/org/domain";
import {
  postOrgDomainVerify,
  postOrgDomainVerifyInitiate,
} from "@/services/org";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import commonServices from "@/services/common/commonServices";
import BaseForm from "../common/form/baseForm.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
const DEFAULT_MAX_WIDTH_MODAL = 65;


export default /*#__PURE__*/_defineComponent({
  __name: 'manageDomainModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  domain: {
    type: Object as PropType<IDomain>,
    required: true,
  },
},
  emits: ["update:show", "update:domain", "delete:domain"],
  setup(__props, { emit }) {

const props = __props;


const commonService = new commonServices();
const loadingVerify = ref(false);

const domainVerifyCode: Ref<string> = ref("");
const errorMessageVerifyDomain: Ref<string> = ref("");
let showRef = ref(props.show);
let notInfoVisible = ref(true);

const dynamicDescriptionTags: any = {
  "app-settings-domain-verify-modal-verify-button-1": {
    openTag: "<span class='tw-font-semibold'>‘",
    closeTag: "’</span>",
  },
};

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) initial();
  },
);

const initial = () => {
  notInfoVisible.value = true;
  fetchDomainVerifyCode();
};

const fetchDomainVerifyCode = async () => {
  try {
    const res = await postOrgDomainVerifyInitiate(
      parseInt(props.domain.domainId) || 0,
    );
    domainVerifyCode.value = get(res, "data.data.verificationToken", "");
  } catch (error: any) {
    domainVerifyCode.value = "";
    if (error && error.data) {
      showErrorAPI(error, Org.orgDomainVerifyInitiate);
    }
  }
};

const handleVerifyDomain = async () => {
  const domainUpdate = await verifyAndUpdateDomainData();

  if (!domainUpdate?.isVerified && errorMessageVerifyDomain.value !== "") {
    const emitData: IToastMessage = {
      variant: ToastVariant.ERROR,
      message: errorMessageVerifyDomain.value,
    };
    EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    return;
  }

  if (domainUpdate?.isVerified) {
    emit("update:domain", domainUpdate);
    showToastSuccessVerify();
    handleCloseModal();
    return;
  }
};

const handleDeleteDomain = async () => {
  emit("delete:domain", props.domain.domainId);
  handleCloseModal();
};

const verifyAndUpdateDomainData = async () => {
  try {
    loadingVerify.value = true;
    commonService.setCursorLoading();
    const res = await postOrgDomainVerify(parseInt(props.domain.domainId) || 0);
    const isVerified = get(res, "data.data.isVerified", false);
    errorMessageVerifyDomain.value = get(res, "data.message", "");

    return { ...props.domain, isVerified };
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.orgDomainVerifyCheck);
      return { ...props.domain, isVerified: false };
    }
  } finally {
    loadingVerify.value = false;
    commonService.setCursorDefault();
  }
};

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const getProcessedUIText = (id: string, tags: any) => {
  return utilities.getProcessedUIText(
    id,
    tags,
    languageSelectedText.value,
    defaultUiText.value,
  );
};

const showToastSuccessVerify = () => {
  const message = getComponentUiText(
    "app-settings-domain-verify-success-message-1",
    false,
    { domain: props.domain.domain },
  );
  const emitData: IToastMessage = { variant: ToastVariant.SUCCESS, message };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const handleCloseModal = (action?) => {
  if (action !== manageDomainActions.delete) {
    showRef.value = false;
  }
  emit("update:show", action);
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%]",
    "max-width": DEFAULT_MAX_WIDTH_MODAL,
    visible: _unref(showRef),
    onClose: handleCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        title: getUiText('app-settings-domain-manage-modal-title-text-1'),
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(props.domain.domain), 1),
          (props.domain.isVerified)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(getUiText("app-component-table-cell-status-dns-verified-1")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(notInfoVisible) && !props.domain.isVerified)
          ? (_openBlock(), _createBlock(NoteInfo, {
              key: 0,
              class: "tw-mt-[20px]",
              onClose: _cache[0] || (_cache[0] = () => (_isRef(notInfoVisible) //@ts-ignore
 ? notInfoVisible.value = false : notInfoVisible = false))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(getUiText("app-settings-domain-manage-modal-note-info-1")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!props.domain.isVerified)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(getUiText("app-settings-domain-verify-modal-dns-text-1")), 1),
              _createElementVNode("p", _hoisted_9, [
                _createElementVNode("span", null, [
                  _createVNode(_unref(VRuntimeTemplate), {
                    template: 
                getProcessedUIText(
                  'app-settings-domain-verify-modal-dns-description-1',
                  dynamicDescriptionTags,
                )
              
                  }, null, 8, ["template"])
                ])
              ]),
              _createVNode(CopyInfo, {
                class: "copy-info-container tw-mt-[25px] tw-pl-[20px] tw-pr-[14px] tw-py-[10px] tw-bg-[#FFFFFF] tw-rounded-md tw-text-[#231F20]",
                text: domainVerifyCode.value,
                "style-icon-css": 'tw-w-[18px] tw-h-[18px]'
              }, null, 8, ["text"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(BaseForm, {
          "enter-event": true,
          show: _unref(showRef),
          "onOn:submit": handleVerifyDomain
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_b_button, {
                  variant: "danger",
                  class: "button-delete tw-py-[11px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
                  onClick: handleDeleteDomain
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getUiText("app-settings-domain-verify-modal-delete-button-1")), 1)
                  ]),
                  _: 1
                })
              ]),
              (!props.domain.isVerified)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_b_button, {
                      variant: "primary",
                      class: "button-verify-later tw-bg-[#ffffff] tw-py-[11px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-mr-[14px] tw-rounded-[27px]",
                      onClick: _cache[1] || (_cache[1] = () => handleCloseModal(_unref(manageDomainActions).verifyLater))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getUiText(
                  "app-settings-domain-verify-modal-verify-later-button-1",
                )), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_button, {
                      variant: "primary",
                      class: "button-setting-add-domain button-verify tw-bg-[#387DFF] tw-py-[11px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
                      type: "submit"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(`${loadingVerify.value ? 'tw-text-transparent' : ''}`)
                        }, _toDisplayString(getUiText("app-settings-domain-verify-modal-verify-button-1")), 3),
                        _createElementVNode("div", {
                          class: _normalizeClass(`tw-w-[39px] tw-h-[39px] tw-flex tw-items-center tw-justify-center tw-absolute tw-top-[-1px] ${
                  loadingVerify.value ? '' : 'tw-hidden'
                }`)
                        }, [
                          _createVNode(_unref(LottieAnimation), {
                            ref: "anim",
                            "animation-data": _unref(ProgressAnimation),
                            "auto-play": true,
                            loop: true
                          }, null, 8, ["animation-data"])
                        ], 2)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})